<!--
 * @Description: 人员列表导出组件
 * @Author: fengal
 * @Date: 2024-06-10 14:43:52
-->
<template>
  <div class="body">
    <el-dialog class="dialog-attendant-export" width="700px" title="人员导出" :visible.sync="visible" 
      :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center v-loading="loading">
      <el-row style="margin: 0 25px" :gutter="0" type="flex" justify="space-between" align="middle">
        <el-col :span="12" style="text-align: left">
          <span class="search-title">机构名称：</span>
          <el-select size="small" style="width: 210px" v-model="params.institutionId" filterable clearable 
            placeholder="请输入/选择" 
            :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
            @visible-change="(visible) => 
              commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
            <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-col>
        <el-col :span="12" style="text-align: left">
          <span class="search-title">审核状态：</span>
          <el-select size="small" style="width: 210px" v-model="params.reviewStatus" clearable filterable 
            placeholder="请选择">
            <el-option v-for="(item, index) in reviewStatusList" :key="index" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin: 25px"  :gutter="0" type="flex" justify="space-between" align="middle">
        <el-col :span="12" style="text-align: left">
          <span class="search-title">人员级别：</span>
          <el-select size="small" style="width: 210px" v-model="params.level" clearable filterable 
            placeholder="请选择">
            <el-option v-for="(value, key, index) in levelMap" :key="index" :label="value" :value="key"></el-option>
          </el-select>
        </el-col>
        <el-col :span="12" style="text-align: left">
          <span class="search-title">服务权限：</span>
          <el-select size="small" style="width: 210px" v-model="params.privilege" clearable filterable 
            placeholder="请选择">
            <el-option v-for="(value, key, index) in privilegeMap" :key="index" :label="value" :value="key">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin: 25px"  :gutter="0" type="flex" justify="space-between" align="middle">
        <el-col :span="12" style="text-align: left">
          <span class="search-title">提现账户：</span>
          <el-select size="small" style="width: 210px" v-model="params.memberStatus" clearable filterable 
            placeholder="请选择">
            <el-option v-for="(value, key, index) in memberStatusMap" :key="index" :label="value" :value="key">
          </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button style="margin-left: 40px" type="primary" @click="handleSubmit">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'

export default {
  name: 'AttendantExportDialog',
  props: ["visible", "filterParams"],

  data() {
    return {
      params: {},
      srcInstitutionList: [],
      institutionList: [],
      levelMap: {},
      reviewStatusList: [],
			privilegeMap: {},
      memberStatusMap: {},
      loading: false,
    }
  },
  
  methods:{
    async initData() {
      this.params = {...this.filterParams}
      delete this.params.page;
      delete this.params.pageSize;
      await this.getFilterDo();
    },

    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_ATTENDANT_FILTER_DO).then(result => {
          if (result != null) {
            this.initFilterData(result.data);
            //如果从机构跳转过来的携带机构ID
            if (this.$route.params.institutionId) {
              this.$set(this.filterParams, 'institutionId', this.$route.params.institutionId)
            }
            resolve();
          }
        })
      })
		},

    initFilterData(filterObj) {
      this.institutionList = filterObj.institutionList;
      this.srcInstitutionList = filterObj.institutionList;
      this.levelMap = filterObj.levelMap;
      this.reviewStatusList = this.commonUtil.map2List(filterObj.reviewStatusMap);
      this.privilegeMap = filterObj.privilegeMap;
      this.memberStatusMap = filterObj.memberStatusMap;
      this.showWithdrawAccount = filterObj.showWithdrawAccount;
    },

    async handleSubmit() {
      let param = {...this.params}

      this.loading = true;
      await Util.exportExcel(Constant.URL_EXPORT_ATTENDANTS, param)
      this.loading = false;
      this.$emit("close-dialog", false);

    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    clearData() {
      this.params = {};
      this.srcInstitutionList = [];
      this.institutionList = [];
      this.levelMap = {};
      this.reviewStatusList = [];
			this.privilegeMap = {};
      this.memberStatusMap = {};
    }
  }
}
</script>

<style scoped>
.dialog-attendant-export /deep/ .el-dialog .el-dialog__header{
  text-align: center;
}

.dialog-attendant-export /deep/ .el-dialog__header .el-dialog__title{
  color: #5B5B5B;
}

.dialog-attendant-export /deep/ .el-empty {
  padding: 0;
}
.dialog-footer {
  text-align: center;
	margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/instmng/components/AttendantExportDialog.vue